import React from "react";
import PropTypes from "prop-types";
import { BellOff, Search, CheckCircle2 } from "lucide-react";
import { NoData } from "../../../../Components/ui";

const NotificationEmptyState = ({
  hasActiveFilters = false,
  isUnreadOnly = false,
  onResetFilters,
  onRefresh,
}) => {
  if (hasActiveFilters) {
    return (
      <NoData
        title="No Matching Notifications"
        description="We couldn't find any alerts matching your search criteria, category, or date range. Try clearing your filters."
        icon={<Search size={32} />}
        actionText="Reset All Filters"
        onAction={onResetFilters}
        minHeight={320}
      />
    );
  }

  if (isUnreadOnly) {
    return (
      <NoData
        title="All Caught Up!"
        description="You have no unread notifications right now. Switch to 'All Alerts' to review previous updates and history."
        icon={<CheckCircle2 size={32} />}
        actionText="Show All Notifications"
        onAction={onResetFilters}
        minHeight={320}
      />
    );
  }

  return (
    <NoData
      title="No Notifications Yet"
      description="There are currently no notifications or activity alerts recorded for your account. New lottery rounds, wins, and updates will appear here in real time."
      icon={<BellOff size={32} />}
      actionText="Refresh Feed"
      onAction={onRefresh}
      minHeight={320}
    />
  );
};

NotificationEmptyState.propTypes = {
  hasActiveFilters: PropTypes.bool,
  isUnreadOnly: PropTypes.bool,
  onResetFilters: PropTypes.func,
  onRefresh: PropTypes.func,
};

export default NotificationEmptyState;
